import animateIn from './animateIn.js';
import swiper from './swiper.js';

const paginationScrollTargets = new WeakSet();

const htmxEvents = {
    init() {
        if (window.htmx) {
            window.htmx.on('htmx:beforeRequest', function (event) {
                const target = event.detail.target;
                target.classList.add('is-loading');

                const trigger = event.detail.elt;
                if (trigger?.closest?.('[data-sprig-pagination-nav]')) {
                    paginationScrollTargets.add(target);
                } else {
                    paginationScrollTargets.delete(target);
                }
            });

            window.htmx.on('htmx:afterRequest', function (event) {
                event.detail.target.classList.remove('is-loading');
            });

            window.htmx.on('htmx:afterSwap', function (event) {
                const target = event.detail.target;

                if (target) {
                    // Small delay to ensure DOM is fully updated
                    requestAnimationFrame(() => {
                        animateIn.refresh(target);
                        // Initialize any new Swiper instances in the swapped content
                        swiper.refresh(target);
                    });
                }

                const scrollTop = target.hasAttribute('data-sprig-scroll-top')
                    ? target
                    : target.querySelector('[data-sprig-scroll-top]');

                if (scrollTop) {
                    const scrollMode = scrollTop.getAttribute(
                        'data-sprig-scroll-top'
                    );
                    const shouldScroll =
                        scrollMode !== 'pagination-only' ||
                        paginationScrollTargets.has(target);

                    if (!shouldScroll) {
                        paginationScrollTargets.delete(target);
                        return;
                    }

                    requestAnimationFrame(() => {
                        const rect = scrollTop.getBoundingClientRect();
                        const offset = rect.top + window.scrollY - 300;
                        window.scrollTo({ top: offset, behavior: 'smooth' });
                    });
                }

                paginationScrollTargets.delete(target);
            });
        }
    }
};

export default htmxEvents;
